<template>
  <div>

    
    <div id="topbar">

      <div class="container ca">
        <a href="/" rel="home" id="logo" title="Skippr">
                          <span class="icon-logo">
                            <img src="./../assets/logo.png" alt="Skippr" width="132px" class="mt-10"/>
                          </span>
        </a>

        <a v-on:click="navToggle" href="#" id="js-nav-trigger">
          <i></i>
          <i></i>
          <i></i>
          <span class="sr-only">Toggle Navigation</span>
        </a>

        <nav id="nav"
             v-bind:class="{'nav-show': navShow}"
             class="nav-menu l">
          <ul v-on:click="navToggle" class="nm ca">
            <li>
              <router-link to="/home">Home</router-link>
            </li>

            <li>
              <!--<router-link to="/product">Product</router-link>-->
              <router-link to="/features">Features</router-link>
              <!--                    <a href="#">Product</a>-->
              <!--                    <ul>-->
              <!--                      <li><router-link to="/features">Features</router-link></li>-->
              <!--&lt;!&ndash;                      <li><router-link to="/pricing">Pricing</router-link></li>&ndash;&gt;-->
              <!--                      <li><hr style="margin:0;"/></li>-->
              <!--                      <li><router-link to="/docker">Docker</router-link></li>-->
              <!--                      <li><router-link to="#">AWS (coming soon)</router-link></li>-->
              <!--                      <li><router-link to="#">Google Cloud (coming soon)</router-link></li>-->
              <!--                      <li><router-link to="#">Azure (coming soon)</router-link></li>-->
              <!--                    </ul>-->
            </li>
            <li>
              <router-link to="/pricing">Pricing</router-link>
              <!--                    <a href="#">Solutions</a>-->
              <!--                    &lt;!&ndash;<router-link to="/solutions">Solutions</router-link>&ndash;&gt;-->
              <!--                    <ul>-->
              <!--                      <li><router-link to="/datalakes">Datalakes</router-link></li>-->
              <!--                      <li><router-link to="/elt-cdc">ELT &amp; CDC</router-link></li>-->
              <!--                      <li><router-link to="/event-sourcing">Event Sourcing</router-link></li>-->
              <!--                      <li><router-link to="/sass-data-integration">SaaS Data Integration</router-link></li>-->
              <!--                    </ul>-->
            </li>
            <li>
              <a href="#">Resources</a>
              <ul>
                <!--                      <li><router-link to="/source-plugins">Docs</router-link></li>-->
                <li><a href="https://docs.skippr.io" target="_blank">Docs</a></li>
                <li><hr style="margin:0;"/></li>
                <li><a href="https://github.com/skipprd/skipprd" target="_blank">GitHub</a></li>
              </ul>
              <!--                    <a href="#">Integrations</a>-->
              <!--                    <ul>-->
              <!--                      <li><router-link to="/source-plugins">Source Plugins</router-link></li>-->
              <!--                      <li><router-link to="/output-plugins">Output Plugins</router-link></li>-->
              <!--                      <li><hr style="margin:0;"/></li>-->
              <!--                      <li><router-link to="/snowflake-skippr">Snowflake</router-link></li>-->
              <!--                      <li><router-link to="/athena-skippr">Athena</router-link></li>-->
              <!--                      <li><router-link to="/dbt-skippr">DBT</router-link></li>-->
              <!--                      <li><router-link to="/deltalake-skippr">Delta Lake</router-link></li>-->
              <!--                      <li><router-link to="/apache-arrow-skippr">Apache Arrow</router-link></li>-->
              <!--                    </ul>-->
            </li>
            <!--                    <li>-->
            <!--                        <a href="/login" class="client-login pull-right" v-on:click="clickEvent('login')">Login</a>-->
            <!--                    </li>-->
          </ul>
        </nav>

        <!--            <a href="https://share.hsforms.com/18QLgOq0vQx675TanD46a8g4q4l7" class="btn btn-secondary r" v-on:click="clickEvent('beta')">Try The Beta</a>-->
        <a href="/deploy-wizard" class="btn btn-secondary r" v-on:click="clickEvent('try_now_free')">Try Now, Free</a>

        <!--          <a href="/login" class="btn client-login r p1-bg mr-10 " v-on:click="clickEvent('login')">Login</a>-->

      </div>
    </div>

  </div>

</template>

<script>



    export default {
      name: 'TopBar',
      props: {
          msg: String
      },
      data: function () {
        return {
          navShow: false
        }
      },
      methods: {
          clickEvent(name) {
            this.$gtag.event('click', {
              event_category: 'nav',
              event_label: name,
            })
          },
          navToggle: function() {
            this.navShow = !this.navShow;
            // some code to filter users
          }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.md-banner {
  background-color: #000;
  color: #efefef;
  overflow: auto;
}

.md-banner p {
  font-size: 2.5em;
  margin-left: 125px;
  padding-top: 22px;
  padding-left: 20px;
}

.md-typeset h4 {
  color: #efefef;
}

.md-grid {
  margin-left: auto;
  margin-right: auto;
  max-width: 100rem;
}
.md-banner__inner {
  font-size: .7rem;
  margin: 0.6rem auto;
  padding: 0 0.8rem;
}
.md-typeset {
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  font-size: .8rem;
  line-height: 1.6;
}

.md-typeset h4 {
  font-weight: 700;
  letter-spacing: -.01em;
  margin: 1em 0;
}


.md-typeset a, .md-typeset a:before {
  transition: color 125ms;
}
.md-typeset a {
  color: #ff0066;
  word-break: break-word;
}
</style>
